import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { Task } from '../../../api/types';
import { useAuth } from '../../../app/providers/useAuth';
import { fetchTasks } from '../api/tasksApi';

// PARA-105 §8.1 — queryKey ['tasks', userId] несёт subtasks_count/
// subtasks_done_count (AC-9) как обычные поля тела ответа, ключ не меняется.
export function useTasks(): UseQueryResult<Task[]> {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['tasks', user?.id],
    queryFn: fetchTasks,
    enabled: user !== null,
  });
}
